interface MonitoringService {
  init: () => void;
  logError: (error: Error) => void;
  logMessage: (message: string) => void;
}

export const MonitoringService: MonitoringService = {
  init: () => {},

  logError: (error: Error) => console.error(error),
  logMessage: (message: string) => console.log(message),
};
